// Route search params, kept apart from the page (2026-10-31): the route file's validateSearch is not code-split, so
// whatever it imports ships in the first-load entry chunk. This file must stay free of React, UI and messages.
import type { RECORD_HISTORY_TAB } from "@offsilo/ui/templates";

// the record-history tab id, written out: importing the value would bring the whole record template into the entry
const HISTORY: typeof RECORD_HISTORY_TAB = "history";
export const DEAL_TABS = ["overview", "proposal", "contract", "files", "notes", "comms", "automations", HISTORY] as const;
export type DealTab = (typeof DEAL_TABS)[number];
export type DealRoomSearch = { tab?: DealTab };
